import { tss } from 'tss-react/mui';
import { InCosmeticsLogo } from './InCosmeticsLogo';
import { CovaloLogo } from './CovaloLogo';
import { legacyBreakpoints } from 'theme/legacyThemeVariables';
import { Box, Button, useTheme } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';

const InCosmeticsHeader = ({
  bg,
  iconFill
}: {
  bg?: string;
  iconFill?: string;
}) => {
  const { classes } = useStyles({ bg });
  const theme = useTheme();
  return (
    <div className={classes.root}>
      <div className={classes.logoWrapper}>
        <CovaloLogo
          className={classes.svg}
          fill={iconFill ?? theme.palette.primary.main}
        />
        <span className={classes.text}>x</span>
        <InCosmeticsLogo className={classes.svg} fill={iconFill ?? '#794B98'} />
      </div>
      <span className={classes.text}>
        <Box sx={{ textAlign: 'center' }}>
          Join us at{' '}
          <Box component={'span'} sx={{ fontWeight: 700 }}>
            in-cosmetics Global
          </Box>{' '}
          - The leading global event for personal care ingredients
          <Button
            variant={'outlined'}
            component={RouterLink}
            color="inherit"
            size="small"
            target="_blank"
            sx={theme => ({
              ml: 2,
              fontWeight: 800,
              '&:hover': {
                background: 'white',
                borderColor: 'white',
                color: theme.palette.primary.main
              }
            })}
            to="https://www.in-cosmetics.com/global/en-gb/lp/welcome-to-in-cosmetics-global.html?utm_source=covalo&utm_medium=barter&utm_campaign=permanent-index-banner"
          >
            REGISTER NOW
          </Button>
        </Box>
      </span>
    </div>
  );
};

export default InCosmeticsHeader;

const useStyles = tss.withParams<{ bg?: string }>().create(({ theme, bg }) => ({
  root: {
    backgroundColor: bg ?? theme.palette.primary.main,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: theme.spacing(2),
    padding: theme.spacing(1),
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
    [legacyBreakpoints.down('xl')]: {
      flexDirection: 'column',
      gap: theme.spacing(0.25),
      alignItems: 'center',
      justifyContent: 'center'
    }
  },
  logoWrapper: {
    display: 'flex',
    gap: theme.spacing(),
    alignItems: 'center'
  },
  text: {
    color: bg ? '#000' : theme.palette.primary.contrastText,
    fontSize: 18,
    fontWeight: 400,
    display: 'flex',
    flexWrap: 'wrap',
    gap: theme.spacing(3),
    alignItems: 'center',

    [legacyBreakpoints.down('lg')]: {
      gap: theme.spacing(1),
      alignItems: 'center',
      flexDirection: 'column'
    },

    [legacyBreakpoints.down('sm')]: {
      fontSize: 14
    }
  },
  svg: {
    '&:hover': {
      cursor: 'default'
    }
  }
}));
